module.exports = {"name":"Hlavička detailu klubu","icon":"<i class='material-icons'>brightness_auto</i>","widget":[{"type":"detail-title","initData":{},"api":{"url":"organizations/detail","id":"clubId"},"paths":{"image":{"src":"logo.image","type":"club"},"title":["baseData.name.v"],"subtitle":["contactAdress.city"]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/club-detail-title/club-detail-title.json
// module id = 313
// module chunks = 0